import React from 'react';
import { SectionTitle } from '../common';
import { useScope } from '../../hooks/useScope';
import { approachItems } from '../../constants/about';

const ApproachSection: React.FC = () => {
  const { scopeData, loading, error } = useScope();

  // Show loading state
  if (loading) {
    return (
      <section className="about-approach-section py-5">
        <div className="container">
          <SectionTitle subtitle="[OUR SCOPE]" title="What We Do" />
          <div className="text-center">
            <p>Loading scope data...</p>
          </div>
        </div>
      </section>
    );
  }

  // Show error state
  if (error) {
    return (
      <section className="about-approach-section py-5">
        <div className="container">
          <SectionTitle subtitle="[OUR SCOPE]" title="What We Do" />
          <div className="text-center">
            <p>Error loading scope data: {error}</p>
          </div>
        </div>
      </section>
    );
  }

  // Show empty state
  if (scopeData.length === 0) {
    return (
      <section className="about-approach-section py-5">
        <div className="container">
          <SectionTitle subtitle="[OUR SCOPE]" title="What We Do" />
          <div className="text-center">
            <p>No scope data available from API</p>
          </div>
        </div>
      </section>
    );
  }

  // Use ONLY API data - no fallbacks whatsoever
  const displayData = scopeData.map((item, index) => {
    console.log(`Processing item ${index}:`, {
      heading: item.heading,
      title: item.title,
      desc: item.desc,
      description: item.description,
      fullItem: item
    });
    
    // Use exactly what the API provides - no fallbacks
    const title = item.heading || item.title || '';
    const description = item.desc || item.description || item.details || item.content || '';
    
    return {
      icon: approachItems[index]?.icon || '📚', // Only keep emoji from static
      title: title,
      description: description
    };
  });

  return (
    <section className="about-approach-section py-5">
      <div className="container">
        <SectionTitle subtitle="[OUR SCOPE]" title="What We Do" />

        <div className="row g-4 mt-2">
          {displayData.map((item, index) => (
            <div key={index} className="col-lg-6 col-md-6">
              <div className="p-4">
                <div className="mb-3" style={{ fontSize: '9rem', textAlign: 'center' }}>
                  {item.icon}
                </div>
                <h3 className="fw-bold fs-5 mb-3 text-center" style={{ fontSize: '2.2rem' }}>
                  {item.title || '[No title from API]'}
                </h3>
                <p
                  style={{
                    color: '#273351',
                    fontSize: '1.8rem',
                    lineHeight: 1.7,
                    textAlign: 'center',
                    margin: 0
                  }}
                >
                  {item.description || '[No description from API]'}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ApproachSection;

